import { Signal } from '@angular/core';
import { Company } from '@app/shared/types/models/company/company.model';
import { IdBased } from '@app/shared/types/models/shared/id-based.model';

export class Cooperation implements IdBased {
  public id: string;
  public status: number;
  public description: string;
  public requestorCompany: Signal<Company | undefined>;
  public receipientCompany: Signal<Company | undefined>;

  public constructor(data: Partial<Cooperation>) {
    Object.assign(this, data);
  }
}
